import React, { useEffect, useRef, useState } from 'react';
import * as pdfjsLib from 'pdfjs-dist';

pdfjsLib.GlobalWorkerOptions.workerSrc =
  'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.6.347/pdf.worker.min.js';

export default function PdfViewer({ url }) {
  const containerRef = useRef(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!url || !containerRef.current) return;

    const container = containerRef.current;
    container.innerHTML = '';

    const loadPdf = async () => {
      try {
        setLoading(true);

        const pdf = await pdfjsLib.getDocument({
          url,
          withCredentials: false,
        }).promise;

        for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
          const page = await pdf.getPage(pageNum);
          const viewport = page.getViewport({ scale: 1.5 });

          const canvas = document.createElement('canvas');
          canvas.height = viewport.height;
          canvas.width = viewport.width;

          canvas.style.display = 'block';
          canvas.style.margin = '0 auto 10px';
          canvas.style.maxWidth = '100%';
          canvas.style.boxShadow = '0 2px 8px rgba(0,0,0,0.3)';
          canvas.style.background = 'white';

          container.appendChild(canvas);

          await page.render({
            canvasContext: canvas.getContext('2d'),
            viewport,
          }).promise;
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    loadPdf();
  }, [url]);

  return (
    <>
      <style>
        {`
        .pdf-spinner {
          width: 60px;
          height: 60px;
          border: 6px solid transparent;
          border-top: 6px solid rgb(22, 98, 115);
          border-radius: 50%;
          animation: pdf-spin 0.9s linear infinite;
        }

        @keyframes pdf-spin {
          to {
            transform: rotate(360deg);
          }
        }
        `}
      </style>

      <div style={{ position: 'relative', height: '100%' }}>
        
        {loading && (
          <div
            style={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'transparent',
              zIndex: 10,
            }}
          >
            <div className="pdf-spinner"></div>
          </div>
        )}

        <div
          ref={containerRef}
          style={{
            background: '#525659',
            padding: '10px',
            height: '100%',
            overflowY: 'auto',
          }}
        />
      </div>
    </>
  );
}